import { addDisconnectListener, addMessageListener, connect, listen, removeDisconnectListener, } from "./api.port";
const platformToStore = {
    chromium: "chrome",
    edgehtml: "edge",
    gecko: "firefox",
};
export const app = {
    get: (what) => send("app.get", { what }),
    getInfo: async () => {
        return Promise.all([app.get("application"), app.get("platform")]).then(([application, rawPlatform]) => {
            const platform = rawPlatform;
            let store;
            if (application !== "edge" && application !== "opera") {
                store = platformToStore[platform] || "chrome";
            }
            else {
                store = application;
            }
            return {
                application,
                platform,
                store,
            };
        });
    },
    listen: (filter) => listen({ type: "app", filter }),
    open: (what) => send("app.open", { what }),
};
export const ctalinks = {
    get: (link, queryParams = {}) => send("app.get", { what: "ctalink", link, queryParams }),
};
export const doclinks = {
    get: (link) => send("app.get", { what: "doclink", link }),
};
export const filters = {
    get: () => send("filters.get"),
    listen: (filter) => listen({ type: "filters", filter }),
};
export const notifications = {
    get: (displayMethod) => send("notifications.get", { displayMethod }),
    seen: () => send("notifications.seen"),
};
export const prefs = {
    get: (key) => send("prefs.get", { key }),
    listen: (filter) => listen({ type: "prefs", filter }),
};
export const premium = {
    activate: (userId) => send("premium.activate", { userId }),
    get: () => send("premium.get"),
    listen: (filter) => listen({ type: "premium", filter }),
};
export const requests = {
    listen: (filter, tabId) => listen({ type: "requests", filter, tabId }),
};
function send(sendType, rawArgs = {}) {
    const args = {
        ...rawArgs,
        type: sendType,
    };
    return browser.runtime.sendMessage(args);
}
export const stats = {
    getBlockedPerPage: (tab) => send("stats.getBlockedPerPage", { tab }),
    getBlockedTotal: () => send("stats.getBlockedTotal"),
    listen: (filter) => listen({ type: "stats", filter }),
};
export const subscriptions = {
    get: (options) => send("subscriptions.get", options),
    getInitIssues: () => send("subscriptions.getInitIssues"),
    listen: (filter) => listen({ type: "subscriptions", filter }),
};
const api = {
    addDisconnectListener,
    addListener: addMessageListener,
    app,
    ctalinks,
    doclinks,
    filters,
    notifications,
    prefs,
    premium,
    requests,
    removeDisconnectListener,
    subscriptions,
    stats,
};
connect();
export default api;
